import React, {  useEffect } from 'react';
import useState from 'react-usestateref';
import '../index.css';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import { FaTrash, FaEraser } from "react-icons/fa";
import {
  listOfFileNamesPageDir,
  copyFile,querySqlRustService,
  testFile,getLog, updateConnection,
   prepareBuild ,extractFuncDescription, createNewJSONContent,
  jsonTooltipExtension,readEachFileConnection, fetchListJsonFiles, getAgentAiConfig,readEachReportData,
  fetchSqliteListTables, fetchSqliteListColumns,readEachConnection,addFile
} from '../authorization/FetchToken';

import Spinner from '../Spinner';
import Navbar from '../components/Navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import HoverBox from '../HoverBox';
import CodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';
import InfoTip from "../components/InfoTip";
import ReactMarkdown from "react-markdown"; 
import Swal from 'sweetalert2';

import {
  Typography,
  Divider,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Button } from "@mui/material";
import { Box, IconButton, Tooltip,InputAdornment,Checkbox } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {SuccessButton,CancelButton,BuildButton} from "../components/buttons.js";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from '../pages/AuthContext';
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";

function EditConnectionPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [isHovered, setIsHovered] = useState(false);

  const [jsonContentFileName, setJsonContentFileName] = useState([]);

  const [contentData, setContentData] = useState(null);
  const [editFileName, setEditFileName] = useState(null);
  const [funcName, setFuncName] = useState(null);
  const [testData, setTestData] = useState(null);
  const [funcCode, setFuncCode] = useState();
  const [funcResult, setFuncResult] = useState(null);
  const [funcCodeFileContent, setfuncCodeFileContent,funcCodeFileContentRef] = useState([]);
  const [funcNameFileContent, setfuncNameFileContent,funcNameFileContentRef] = useState([]);
  const [funcDesc, setfuncDesc] = useState(null);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [listOfJsonFileToDisplay, setListOfJsonFileToDisplay] = useState([]);

  const [fileDir, setfileDir,fileDirRef] = useState([]);
  //const [connName, setConnName] = useState([]);

  const { event,configTypeSelected,configName,configFeature,filePathSelected} = location.state || {};

  // Use the connection data from location state to populate the form fields
  const [formData, setFormData] = useState();
  const [jsonError, setJsonError] = useState(null);

  const [dataFiles, setDataFiles] = useState([]);
  const [selectedFilePath,setSelectedFilePath,selectedFilePathRef] = useState('');
  const [firstFolderName, setFirstFolderName] = useState('');
  const [logContent, setLogContent] = useState('');
  const [offset, setOffset] = useState(0);
  const [version, setVersion,versionRef] = useState("1.0.0");
  const [feature, setFeature,featureRef] = useState("files");
  const [showBuildSuccessMessage, setShowBuildSuccessMessage] = useState(false);
  const [includeSuperset, setIncludeSuperset] = useState(false);
  const [includeLitestream, setIncludeLitestream] = useState(false);
  const [license, setLicense] = useState("");
  const [exampleFileConfig, setExampleFileConfig] = useState("");
  const [exampleMqttConfig, setExampleMqttConfig] = useState("");
  const [loggedInUserRole,setloggedInUserRole] = useState("")
  const [configType, setConfigType] = useState("");
  const [sourceType, setSourceType] = useState("file");
  const [queries, setQueries] = useState([]);
  const [finalQuery, setFinalQuery] = useState(false);
  const [additionalOptions, setAdditionalOptions] = useState(false);
  const [exportResults, setExportResults] = useState(false);
  const [exportFormat, setExportFormat] = useState("csv");
  const [exportDest, setExportDest] = useState("");
  const [finalQueryDescription, setFinalQueryDescription] = useState("");
  ////////////////////////////
  let tableList = [];
  let columnList = [];
  let partitionByValue;
  let orderByValue;
  let selectedTableName;
  let columnTypeList = [];
  let currentTableName;
  const [selectedDatabase, setSelectedDatabase] = useState('');
  const [databasesList, setDatabasesList,databasesListRef] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [leftList, setLeftList] = useState([]);
  const [rightList, setRightList] = useState([]);
  const [tableDataList, setTableDataList] = useState(tableList.length > 0 ? tableList : []);
  const connectionType = 'SQLite';
  const [jsonCopy, setJsonCopy] = useState();
  let selectedTableColumnsValue = [];
  const [selectedTableColumns, setSelectedTableColumns] = useState(
    selectedTableColumnsValue && selectedTableColumnsValue.length > 0 ? selectedTableColumnsValue : ' ');
  const [columnTypeListValue, setColumnTypeListValue] = useState(columnTypeList.length > 0 ? columnTypeList : []);
  const [orderBy, setOrderBy] = useState(
    orderByValue && orderByValue.length > 0 ? orderByValue : ' ');
  const [partitionBy, setPartitionBy] = useState(
    partitionByValue && partitionByValue.length > 0 ? partitionByValue : ' '); 
  const [columnDataList, setColumnDataList] = useState(columnList.length > 0 ? columnList : []);
  const [isOpenDatabases, setIsOpenDatabases] = useState('');
  const [isOpenFunctions, setIsOpenFunctions] = useState('');
  const [fileType, setFileType] = useState("csv");
  const [headerIdentifier, setHeaderIdentifier] = useState("");
  const [headerRowIdentifier, setHeaderRowIdentifier] = useState("");
  const [headerRowNumber, setHeaderRowNumber] = useState("");
  const [headerSelection, setHeaderSelection] = useState("");
  const [trimSuffix, setTrimSuffix] = useState("");
  const [manualSchema, setManualSchema] = useState(false);
  const [activeDrawer, setActiveDrawer] = useState(null); 
  const [model, setModel] = useState("claude-haiku-4-5-20251001"); 
  const [apiKey, setApiKey] = useState("");
  const [showKey, setShowKey] = useState(false);
  const [resultRows, setResultRows] = useState([]);
  const [resultCols, setResultCols] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage,errorMessageRef] = useState('');
  const [steps, setSteps] = useState([]);
  const [depth, setDepth] = useState(1);
  const [contentTag, setcontentTag] = useState("");
  const [visible,  setVisible] = useState(true);
  const [doc, setDoc] = useState("");
  const [openDoc, setOpenDoc] = useState(false);
  const isDisabled = !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin");

  ///////////////////////////
  
  const [sourceConfig, setSourceConfig] = useState({
    host:"",
    topic: "",
    port: "1883",
    database: "test_database",
    stagingTable: "test_staging_table",
    dirPath: "",
    successPath: "",
    failurePath: "",
    fileType:fileType,
    depth:1,
    failure_dir: 0, 
    contentTag:"", 
    delimiter:",", 
  });
  
  //const [sourceConfig, setSourceConfig] = useState({})

  const addQuery = () => {
    setQueries([...queries, { finalQueryDescription:"", description: "", validation: "",finalQuery:false,schedule:"",disableGeneration:false }]);
    setSourceConfig({
      ...sourceConfig,
      queries: queries
    })
  };

  const updateQuery = (index, field, value) => {
    const updated = [...queries];
    updated[index][field] = value;
    setQueries(updated);
    setSourceConfig({
      ...sourceConfig,
      queries: updated,
    })
  };

  const deleteQuery = (index) => {
    setQueries(queries.filter((_, i) => i !== index));
    setSourceConfig({
      ...sourceConfig,
      queries: queries.filter((_, i) => i !== index)
    })
  };

  const clearSourceConfig = () => {
    setSourceConfig({
      topic: "",
      database: "",
      stagingTable: "",
      dirPath: "",
    });
  };

  const clearAdditionalProps = () => {
    setSourceConfig((prev) => ({
      ...prev,
      headerIdentifier: "",
      headerRowIdentifier: "",
      headerRowNumber: "",
      headerSelection: "",
      trimSuffix:"",
      additionalOptions:false
    }));
    setHeaderIdentifier("")
    setHeaderRowIdentifier("")
    setHeaderRowNumber("")
    setHeaderSelection("")
    setTrimSuffix("")
    setAdditionalOptions(false)

  };


const { userSessionRef} = useAuth();

  useEffect(() => {
    if (!userSessionRef) return;
    if (configFeature!=undefined){
    readConfigFile(configName,configFeature);
    } else {
      readConfigFile(configName,featureRef.current);
    }
    //fetchListDataConnections();
    getUploadedFiles();
    console.log("version,feature::1", versionRef.current,featureRef.current);
    setEditFileName(configName);
    //setFeature(configFeature);
    setSelectedFilePath(filePathSelected);
    fetchLogs(Math.max(offset - 50, 0));
    //setConfigType(configTypeSelected);
    setloggedInUserRole(userSessionRef.current["role"])
  }, [feature,userSessionRef]);

  useEffect(() => {
    if (activeDrawer === "databases") {
      fetchListDataConnections();
    }
  }, [activeDrawer]);

  useEffect(() => {
    if (showErrorMessage) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [showErrorMessage]);

  useEffect(() => {
    if (showErrorMessage) {
      const el = document.getElementById("error-banner");
      if (el) el.scrollIntoView({ behavior: "auto", block: "center" });
    } else if (showSuccessMessage) {
      const el = document.getElementById("success-banner");
      if (el) el.scrollIntoView({ behavior: "auto", block: "center" });
    }
  }, [showErrorMessage, showSuccessMessage]);

useEffect(() => {
  if (location.state?.runTest) {

      handleTest(event);

      // Remove the flag so refresh doesn't trigger it again
      navigate(location.pathname, {
          replace: true,
          state: {
              ...location.state,
              runTest: false,
          },
      });
  }
}, []);

  const getUploadedFiles = async () => {
    try {
      const path =  "/home/stateFiles/" + userSessionRef.current["orgName"] + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/uploads"
      const connectionsData = await listOfFileNamesPageDir(path);
  
      setDataFiles(connectionsData);
      setFirstFolderName(connectionsData.info.name || '');
    } catch (error) {
      console.error('Error fetching connections:', error);
    }
  };
  

  const readConfigFile = async (configName,configFeature) => {
    try {
      const file = configFeature + "/" + configName;

      const fileContent = await readEachConnection("config",file,userSessionRef.current["orgName"]);
      console.log("fileContent::1", fileContent);
      setFormData(JSON.stringify(fileContent, null, 2));
      setfileDir(fileContent.dir_path);
      setFeature(configFeature);
      console.log("version::11",fileContent._invertible_version)
      if (fileContent._invertible_version!=undefined) {
        setVersion(fileContent._invertible_version);
      }
      
      
      console.log('agentConfigFile:11');
      const agentConfigFile = configName + "_" + "aiagent_config"
      const agentConfigContent = await readEachConnection("aiagent",agentConfigFile, userSessionRef.current["orgName"]);
      console.log('agentConfigFile:45', agentConfigContent.fileType);
      if (agentConfigContent!=undefined){
        setConfigType("agentai");
        console.log('agentConfigFile:44',agentConfigContent.queries);
        setSourceConfig(agentConfigContent);
        setHeaderIdentifier(agentConfigContent.headerIdentifier);
        setHeaderRowIdentifier(agentConfigContent.headerRowIdentifier);
        setHeaderRowNumber(agentConfigContent.headerRowNumber)
        setAdditionalOptions(agentConfigContent.additionalOptions);
        setTrimSuffix(agentConfigContent.trimSuffix);
        setFileType(agentConfigContent.fileType);
        setHeaderSelection(agentConfigContent.headerSelection);
        setManualSchema(agentConfigContent.manualSchema);
        if (agentConfigContent.queries!=undefined) {
         setQueries(agentConfigContent.queries);
        }
        setFinalQuery(agentConfigContent.finalQuery);
        setAdditionalOptions(agentConfigContent.additionalOptions);
        setExportFormat(agentConfigContent.exportFormat);
        setExportDest(agentConfigContent.exportDest);
        setFinalQueryDescription(agentConfigContent.finalQueryDescription);
        
      }

      //console.log(JSON.stringify(formData) + "formData");
    } catch (error) {
      console.error('Error fetching connections:', error);
    }
  };

  const handleSave = async (event) => {

    console.log("event::1", JSON.stringify(event));
    setLoading(true);

    try {
      const file = featureRef.current + "/" + editFileName
      const updatedData = await updateConnection(event,file,userSessionRef.current["orgName"], "default");
      console.log('Created Data:', updatedData);
      const agentConfigFile = editFileName + "_" + "aiagent_config"
      const updatedAgentConfig = await addFile(JSON.stringify(sourceConfig),agentConfigFile, "aiagent",userSessionRef.current["orgName"]);
      console.log('agentConfigFile:43:', JSON.stringify(sourceConfig));

    } catch (error) {
      console.error('Error:', error);
    }
    setLoading(false);
  };


const fetchLogs = async (offset) => {
    //always the user has to select data file name for logs
    try {
      const dataFileName = selectedFilePath.split('/').pop();
      const org_name = userSessionRef.current["orgName"]
      //const file_path = "/home/read_csv_to_dataframe/" + formData.dir_path  + "/" +  dataFileName;
      const userName = userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
      let file_path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` + "data_mount/" + org_name + "/" + fileDirRef.current + "/" + userName + "/" +  dataFileName;
      if (featureRef.current == "mqtt"){
        file_path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` + "data_mount/" + org_name + "/mqtt_test/" + userName + "/" + dataFileName;
      }
      const database_path = "/home/invertible_databases/" + org_name + "/public.db"
      const logText = await getLog(offset,database_path,file_path,org_name);
      const rawArray = JSON.parse(logText);
      //const parsedLogLines =  rawArray.filter((line) => line !== ',') // filter out the stray commas
      const parsedLogLines = rawArray
      .reverse()
      .map((entry) => {
        try {
          const parsed = JSON.parse(entry);
          let color = '';

          if (parsed.log_level === 'INFO') {
            color = 'green';
          } else if (parsed.log_level === 'ERROR') {
            color = 'red';
          } else if (parsed.log_level === 'WARN') {
            color = 'yellow';
          }

          return `${parsed.log_time} <span style="color:${color}; font-weight:600;">${parsed.log_level}</span> ${parsed.message}`;
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean);

      // ✅ Prevent moving forward if no logs
      if (parsedLogLines.length === 0 && offset!== 0) {
        setSuccessMessage("No more logs available");
        setShowSuccessMessage(true)
        return; // don't update offset or logs
      }

      setLogContent(parsedLogLines.join('\n'));
      setOffset(offset);


    } catch (error) {
      console.error('Error:', error);
    }
  };


/*
const fetchLogs = async (offset) => {
  //always the user has to select data file name for logs
  try {
    const dataFileName = selectedFilePath.split('/').pop();
    const org_name = userSessionRef.current["orgName"]
    //const file_path = "/home/read_csv_to_dataframe/" + formData.dir_path  + "/" +  dataFileName;
    const userName = userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
    let file_path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` + "data_mount/" + org_name + "/" + fileDirRef.current + "/" + userName + "/" +  dataFileName;
    if (featureRef.current == "mqtt"){
      file_path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` + "data_mount/" + org_name + "/mqtt_test/" + userName + "/" + dataFileName;
    }
    const database_path = "/home/invertible_databases/" + org_name + "/public.db"
    const logText = await getLog(offset,database_path,file_path,org_name);
    const rawArray = JSON.parse(logText);
    //const parsedLogLines =  rawArray.filter((line) => line !== ',') // filter out the stray commas
    const parsedLogLines = rawArray
    .reverse()
    .map((entry) => {
      try {
        const parsed = JSON.parse(entry);
  
        let color = "";
  
        if (parsed.log_level === "INFO") {
          color = "green";
        } else if (parsed.log_level === "ERROR") {
          color = "red";
        } else if (parsed.log_level === "WARN") {
          color = "yellow";
        }
  
        return {
          log_time: parsed.log_time,
          log_level: parsed.log_level,
          message: parsed.message,
          html: `${parsed.log_time} <span style="color:${color}; font-weight:600;">${parsed.log_level}</span> ${parsed.message}`,
        };
      } catch (e) {
        return null;
      }
    })
    .filter(Boolean);
  
    const startedEntries = parsedLogLines
  .map((entry, index) => ({
    entry,
    index,
    timestamp: new Date(entry.log_time).getTime(),
  }))
  .filter((item) =>
    item.entry.message.includes("Started File Processing by user")
  );

if (startedEntries.length > 0) {
  // Find the matching message with the latest timestamp
  const latestStarted = startedEntries.reduce((latest, current) =>
    current.timestamp > latest.timestamp ? current : latest
  );

  const startedEntry = parsedLogLines.splice(latestStarted.index, 1)[0];

  // Put only that entry at the beginning
  parsedLogLines.unshift(startedEntry);
}
  const finalLogLines = parsedLogLines.map((entry) => entry.html);
  console.log("FIRST LOG:", finalLogLines[0]);
  
  setLogContent(finalLogLines.join("\n"));
  setOffset(offset);
  
  } catch (error) {
    console.error('Error:', error);
  }
};
*/



const handleTest = async (event) => {
    ///createStateFileevent.preventDefault();
    //setLoading(true);
    
    try {
      setLoading(true);
      const ev = JSON.parse(event);
      setfileDir(ev.dir_path);
      const configFile = featureRef.current + "/" + editFileName
      const updatedData = await updateConnection(event, configFile,userSessionRef.current["orgName"],"default");
      const userName =userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
      const agentConfigFile = editFileName + "_" + "aiagent_config"
      const updatedAgentConfig = await addFile(JSON.stringify(sourceConfig),agentConfigFile, "aiagent",userSessionRef.current["orgName"]);
      console.log('agentConfigFile:43:', JSON.stringify(sourceConfig));
      console.log('Submitted_event_for_test:', ev.dir_path,JSON.parse(event).dir_path,selectedFilePathRef.current);
      if (featureRef.current == "mqtt"){
        ev.dir_path="mqtt_test"
      }
      //Copy data file
      const dataFile = selectedFilePathRef.current.split('/').pop();
      console.log("dataFile::1",dataFile);
      const org_name = userSessionRef.current["orgName"]
      console.log("dataFile::12",org_name,ev.dir_path);
      const cpDataFile = await copyFile(selectedFilePathRef.current,`${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org_name + "/" + ev.dir_path + "/" + userName + "/")
      //Copy data file
      const cpFuntionsFile = await copyFile("/home/stateFiles/" + org_name + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/functions/functions" , `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}${org_name}/functions/functions`,org_name)
      //let dataFileName = event.data_file_name.split('/');
      const testResponse = await testFile(ev, configFile, selectedFilePathRef.current,userName,featureRef.current,org_name);
      console.log("testResponse.status::1",testResponse.status,testResponse.body)
      setSuccessMessage("Processing started in background.Please check logs to track progress.")
      setShowSuccessMessage(true)
      console.log('Created Data:', testResponse );
      //const file_path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}` +  "data_mount/" + fileDirRef.current + "/" + dataFile;
      fetchLogs(Math.max(offset - 50, 0));
      setLoading(false);

    } catch (error) {
      console.error('Error:', error.message);
      setErrorMessage(error.message);
      setShowErrorMessage(true);
      setLoading(false);
    }
  };

const handleConfigChange = (type) => {
  setConfigType(type);
  //setFormData(type === "file" ? JSON.stringify(exampleFileConfig,null,2) : JSON.stringify(exampleMqttConfig,null,2));
  setJsonError(null);
};

const handleBuild = async () => {
    setLoading(true);
    setShowSuccessMessage(false); // reset before starting
    try {
      console.log("versions::1",version)
      const resp = await prepareBuild(editFileName, version, feature,userSessionRef.current["orgName"],includeSuperset,license);
      setSuccessMessage(`Successfully added build version ${version}. Please access it in page Manage Builds.`)
      setShowSuccessMessage(true);
      setLoading(false);
      //setTimeout(() => setShowBuildSuccessMessage(false), 3000); // auto-hide after 3s
    } catch (err) {
      console.error('Build failed', err);
      // optionally show a failure message
      setLoading(false);
      setErrorMessage(err.message);
      setShowErrorMessage(true);
    }
  };


const DRAWER_WIDTHS = {
  logs: 700,
  databases: 600,
  functions: 700,
};


///////////////////////////////////////////

const fetchListDataConnections = async () => {
  try {
    const path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` +  userSessionRef.current["orgName"] + "/databases";
    const connectionsData = await listOfFileNamesPageDir(path);
    console.log("data:22",JSON.parse(JSON.stringify(connectionsData)));
    if (connectionsData!==undefined) {
      const firstdatabase = JSON.parse(JSON.stringify(connectionsData?.children[0]?.path));
      const event = {"target":{"value":firstdatabase}};
      handleDatabaseChange(event)
      //setJsonData(connectionsData);
      setDatabasesList(connectionsData);
    } else {
      setDatabasesList([]);

    } 
  } catch (error) {
    console.error('Error fetching sqlite databases:', error);
  }
};

const handleInputChange = async (index, field, value) => {
  let tableName = `${selectedDatabase}.${selectedTable}`
  currentTableName = tableName;
  console.log("handleInputChange_json::10", tableName, index, field, value,rightList,index)
  const col = rightList[index]["name"]
  console.log("handleInputChange_json::1",JSON.stringify(jsonCopy))
  //j[tableName][col][field]=value
  if (connectionType == 'SQLite'){
      tableName= tableName.replaceAll("/",".")  
  };
  let updatedJson
  if (jsonCopy[tableName]!==undefined){   
  console.log("in update json::1", JSON.stringify(jsonCopy))
  updatedJson = {
      ...jsonCopy,
      [tableName]: jsonCopy[tableName].map(item =>
          item.name === col ? { ...item, [field]: value } : item
      )
  };
      console.log("in update json::2  ", updatedJson)
  json = updatedJson;
  setJsonCopy(updatedJson);
} 
  console.log("handleInputChange::10", tableName, index, field, value)
  console.log("handleInputChange::2", updatedJson)
  //setJson(updatedJson);
  console.log("handleInputChange::3", jsonCopy)
  console.log("createJson::2", jsonCopy)
  //setRightList(index, field, value)
  setRightList(rightList.map((column, i) => i === index ? { ...column, [field]: value } : column));
  //console.log("handleInputChange::2", rightList)
};

const renderTable1Options = () => {
  return tableDataList.map((table, index) => (
      <option key={index} value={table}>
          {table}
      </option>
  ));
};

const handleTableChange = async (event, selectedTable) => {
  selectedTableName = event.target.value;
  setLoading(true);
  setSelectedTable(selectedTableName);

  let columnNames = [];
  columnNames = await fetchSqliteListColumns(selectedDatabase, selectedTableName);
  console.log("columnNames::4",JSON.stringify(columnNames));
  setLeftList(columnNames.map(leftList => JSON.parse(JSON.stringify(leftList[0]))));
  setColumnDataList(columnNames.map(column => column[0]));
  //const tableName = `${selectedDatabase}.${selectedTableName}`;
  currentTableName = selectedTableName;
  //console.log("tableName::3", tableName);
  const res = await readData(columnNames, selectedTableName);
  if (res.length>0) {
    setRightList(res);
    }
  handleExecuteRust(selectedDatabase,selectedTableName);

  setLoading(false);
  };
  

const renderSchemaOptions = () => {
  return databasesListRef.current?.children?.map((file, index) => (
      <option key={index} value={file.path}>
        {file.info?.name || file.path}
      </option>
  ));
  
};

const readData = async (leftList,tableName) => {
  const filteredList =[];
  //const tableName = `${connectionName}.${selectedDatabase}.${selectedTable}`
  try {
      const reportData = await readEachReportData(
          "default_user",
          tableName,
          userSessionRef.current["orgName"]
      );
if (reportData !== undefined) {
  leftList.forEach(columnName => {
      const filteredItems = reportData[tableName]?.filter(item => item.name === columnName[0]) || [];

      if (filteredItems.length > 0) {
          filteredItems.forEach(item => {
              filteredList.push({
                  "name": columnName[0],
                  "dataType": item.dataType,
                  "description": item.description
              });
          });
      } else {
          filteredList.push({
              "name": columnName,
              "dataType": "",
              "description": ""
          });
      }
  });

} else {
      leftList.forEach(column => {
          filteredList.push({ "name": column[0], "dataType": column[1], "description": "" });
      });
}
  json[tableName]=filteredList;
  setJsonCopy(json)
  return filteredList
  //setRightList(filteredList)
  //console.log("l::4", rightList)
} catch (error) {
  console.error('Error fetching connections:', error);
  return [];
}
}


const handleDatabaseChange = async (event) => {
  const schema = event.target.value;
  console.log("data:33",schema,event);
  var message_list = []

  setLoading(true);
  setSelectedDatabase(schema);
  let tableNames = [];
  let columnNames = [];
  tableNames = await fetchSqliteListTables(schema);
  console.log("tableNames::1",JSON.stringify(tableNames));
  setSelectedTable(tableNames[0]);
  setTableDataList(tableNames);
  if (tableNames && tableNames.length > 0) {
      const tableName = JSON.parse(JSON.stringify(tableNames[0]));
      columnNames = await fetchSqliteListColumns(schema, tableName);
      setLeftList(columnNames.map(leftList => JSON.parse(JSON.stringify(leftList[0]))));
      currentTableName = tableName;
      let database = schema;
      if (connectionType == 'SQLite'){
          database= database.replaceAll("/",".")  
      };
      //const tableName = `${selectedDatabase}.${selectedTable}`   
      const fullTableName = `${database}.${tableName}`      
      const res = await readData(columnNames, fullTableName);
      if (res.length>0) {
      setRightList(res);
      }
      //  const columns = selectedTable.columns;
      setSelectedTableColumns(columnNames[0]);
      setColumnTypeListValue(columnNames[1]);
      // setSelectedTableColumns(response[0][0]);
      setOrderBy(columnNames[0][0]);
      //setShowWindowFunction(false);
      setPartitionBy(columnNames[0][0]);
      handleExecuteRust(schema,tableNames[0]);
  } else {

    setRightList([]);
    setResultCols([]);
    setResultRows([]);

  }

  setLoading(false);
  };

///////////////////////////////////////

  const handleAgentAi = async () => {
    setLoading(true)
    let source = "";
    if (featureRef.current=="mqtt") {
      source=sourceConfig.topic
    } else {
      source=sourceConfig.dirPath
    }
    console.log("deleteQuery::1",queries)

  const resp = await getAgentAiConfig(featureRef.current,source,sourceConfig.host,sourceConfig.database,sourceConfig.stagingTable,
      queries,finalQueryDescription,exportFormat,exportDest,headerIdentifier,headerRowIdentifier,headerRowNumber,headerSelection,trimSuffix,manualSchema,sourceConfig.successPath,sourceConfig.failurePath,model,apiKey,sourceConfig.depth,sourceConfig.contentTag,fileType,formData,userSessionRef.current["orgName"],sourceConfig.port)
    
    const data = await resp.text();
    if (!resp.ok || resp==undefined) {
      console.log("AgentAiresp::101",JSON.parse(data).detail);
      setErrorMessage(JSON.parse(data).detail);
      setShowErrorMessage(true)
    } else{
      const inner = JSON.parse(data);
      //Step 2: Beautify with 2 spaces
      //const pretty = JSON.stringify(resp,null,2);
      setfileDir(JSON.parse(inner).dir_path);
      setFormData(inner);
      console.log("AgentAiresp::102",JSON.parse(inner).dir_path)
      console.log("keys:", Object.keys(inner));
  }
    setLoading(false)
  };

  const handleExecuteRust = async (database,table) => {
    try {
      const query = `select * from ${table} limit 2;`
  
      console.log('handleExecuteRust::1', query);
      const json = await querySqlRustService(database, query,userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, ''),userSessionRef.current["orgName"]);
      console.log('handleExecuteRust::11',json);

      if (!json.results) {
        setResultCols([]);
        setResultRows([]);
      }
      const data = json.results;
  
      console.log('handleExecuteRust::112', JSON.stringify(data));
      if (!Array.isArray(data) || data.length < 1) {
        throw new Error("Empty or invalid result from Rust SQL engine");
      }
  
      // First row is header
      const [columns, ...rows] = data;
      console.log('handleExecuteRust::raw output::2', columns);
  
      // Use in React Table
      setResultCols(columns);  // ['col1', 'col2', ...]
      setResultRows(rows);     // [['val1', 'val2', ...], ...]
  
    } catch (err) {
      setResultCols([]);
      setResultRows([]);
      //alert(`Execution error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  function AlertBanner({ message, onClose }) {
    if (!message) return null;
  
    return (
      <div style={{
        backgroundColor: '#fdecea',
        color: '#611a15',
        padding: '10px 20px',
        border: '1px solid #f5c6cb',
        borderRadius: '5px',
        marginBottom: '1rem',
        position: 'relative'
      }}>
        <span>{message}</span>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '5px',
            right: '10px',
            background: 'none',
            border: 'none',
            fontSize: '16px',
            color: '#611a15',
            cursor: 'pointer'
          }}
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    );
  }


  return (
  <div className="main-container">

  <div className="form-container">

  {showErrorMessage && (
  <div
    className="error-message"
    id="error-banner"
    style={{
      position: "relative",
      backgroundColor: "#fee2e2",
      color: "#b91c1c",
      padding: "12px 40px 12px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <span>ERROR OCCURRED: {errorMessageRef.current}</span>
    <button
      onClick={() => setShowErrorMessage(false)}
      style={{
        position: "absolute",
        top: "8px",          // moves it to the top
        right: "10px",       // aligns it to the right edge
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#b91c1c",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "0", 
      }}
    >
      ×
    </button>
  </div>
)}

{showSuccessMessage && (
  <div
    className="success-message"
    id="success-banner"
    style={{
      position: "relative",
      backgroundColor: "#dcfce7",
      color: "#166534",
      padding: "12px 40px 12px 12px",
      borderRadius: "6px",
      marginBottom: "12px",
      fontWeight: 500,
      fontSize: "14px",
    }}
  >
    <span>{successMessage}</span>
    <button
      onClick={() => setShowSuccessMessage(false)}
      style={{
        position: "absolute",
        top: "8px",          // moves it to the top
        right: "10px",       // aligns it to the right edge
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#b91c1c",
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "0", 
      }}
    >
      ×
    </button>
  </div>
)}

        {loading && (
          <div className="overlay">
            <div className="loading-container">
              <Spinner />
              <p className="please-wait">Please wait...</p>
            </div>
          </div>
        )}

{featureRef.current === "mqtt" && (
  <Typography
    variant="body2"
    sx={{
      mt: 2,
      mb: 1,
      color: "text.secondary",
      fontStyle: "italic",
    }}
  >
    Note: MQTT testing in the web app is for smoke testing only, to quickly
    verify that the pipeline is working. The pipeline stops once the first 5 messages of the
    selected file are processed. On deployment, the MQTT pipeline will
    continuously process incoming messages as expected.
  </Typography>
)}


        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "16px" }}>
         <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Edit Configuration : {editFileName}
         </Typography>
         </div>

         <div style={{ maxWidth: 800, margin: "0 auto", padding: "24px", marginBottom: "-32px"  }}>
        <Typography variant="h7" sx={{ fontWeight: 400 }}>
           Use AI Agent to edit configuration or manually edit in Code Editor below.
         </Typography>
       </div>

{/*///////////////////////////////////////////////////////////*/}
<div style={{ maxWidth: 800, margin: "0 auto", padding: "24px", marginBottom: "-32px"  }}>
  <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
       <CardContent sx={{ p: 3 }}>
      <div className="form-group">
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
           Feature
         </Typography>
         <InfoTip
        keyword="feature"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
         <Divider sx={{ my: 2 }} />
        <select
          id="featureSelect"
          className="form-control"
          value={featureRef.current}
          onChange={(e) => setFeature(e.target.value)}
          style={{
            width: "300px",   // or "100%" if you want full width
            padding: "8px",
            fontSize: "16px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }} 
        >
          <option value="files">files</option>
          <option value="mqtt">mqtt</option>
        </select>
      </div>
      </CardContent>
  </Card>
  </div>

{/* Conditionally render AgentAI UI when selected */}
{configType === "agentai" && featureRef.current === "files" && (
   <div style={{ maxWidth: 800, margin: "0 auto", padding: "24px" }}>
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Generate Configuration with AI Agent
    </Typography>
  {/* Model Selection */}
  <div style={{ marginTop: "16px" }}>
   <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
     <CardContent sx={{ p: 3 }}>
     <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
         <Typography variant="h6" sx={{ fontWeight: 600 }}>
           Select LLM Model
         </Typography>
         <InfoTip
        keyword="select_llm"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
       <Divider sx={{ my: 2 }} />
       <div
         style={{
           display: "flex",
           alignItems: "center",
           gap: "8px",
           marginTop: "16px",
         }}
       >
       </div>
         <div style={{ display: "grid", gap: "16px", marginTop: "12px" }}>
           <FormControl fullWidth size="small">
             <InputLabel>LLM Model</InputLabel>
             <Select
               value={model}
               onChange={(e) => {
                setModel(e.target.value)
                setSourceConfig({
                  ...sourceConfig,
                  model: e.target.value
                })
               }}
               label="LLM Model"
             >
            <MenuItem value="claude-haiku-4-5-20251001">claude-haiku-4-5-20251001</MenuItem>
            <MenuItem value="gpt-4o-mini">gpt-4o-mini(OpenAI)</MenuItem>
             </Select>
           </FormControl>
           <TextField
      label="API Key"
      fullWidth
      size="small"
      type={showKey ? "text" : "password"} // hide/show text
      value={apiKey}
      onChange={(e) => setApiKey(e.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowKey(!showKey)}
              edge="end"
              size="small"
              aria-label="toggle API key visibility"
            >
              {showKey ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
         </div>
     </CardContent>
   </Card>
   </div>
   {/* Source Config */}
   <Card variant="outlined" sx={{ borderRadius: 6, boxShadow: 1, mb: 3 }}>
     <CardContent sx={{ p: 3 }}>
     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
         <Typography
           variant="h6"
           sx={{ fontWeight: 600, display: "flex", justifyContent: "space-between", alignItems: "center" }}
         >
           Set Mandatory fields in config
        </Typography>
        <InfoTip
        keyword="mandatory_config_fields"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
        <br></br>
         <Button
           variant="outlined"
           size="small"
           startIcon={<FaEraser />}
           onClick={clearSourceConfig}
           sx={{ textTransform: "none" }}
         >
           Clear
         </Button>

       <Divider sx={{ my: 2 }} />

         <div style={{ display: "grid", gap: "16px" }}>
           <TextField
             label="Directory Path"
             size="small"
             value={sourceConfig.dirPath}
             onChange={(e) =>
               setSourceConfig({ ...sourceConfig, dirPath: e.target.value })
             }
           />
           <TextField
             label="Move Success files to"
             size="small"
             variant="outlined"
             value={sourceConfig.successPath || ""}
             onChange={(e) =>
               setSourceConfig({ ...sourceConfig, successPath: e.target.value })
             }
           />
           <TextField
             label="Move Failed files to"
             size="small"
             value={sourceConfig.failurePath || ""}
             onChange={(e) =>
               setSourceConfig({ ...sourceConfig, failurePath: e.target.value })
             }
           />
           <FormControl fullWidth size="small">
            <InputLabel id="file-type-label">File Type</InputLabel>
            <Select
              labelId="file-type-label"
              value={fileType}
              label="File Type"
              onChange={(e) =>  { setFileType(e.target.value)
              setSourceConfig({
                ...sourceConfig,
                fileType: e.target.value,
              })
            }}
            >
              <MenuItem value="">
                <em> </em>
              </MenuItem>
              <MenuItem value="csv">CSV</MenuItem>
              <MenuItem value="json">JSON</MenuItem>
              <MenuItem value="excel">Excel</MenuItem>
              <MenuItem value="xml">XML</MenuItem>
            </Select>
          </FormControl>
           <TextField
             label="Database"
             size="small"
             value={sourceConfig.database}
             onChange={(e) =>
               setSourceConfig({ ...sourceConfig, database: e.target.value })
             }
           />
           <TextField
             label="Staging Table"
             size="small"
             value={sourceConfig.stagingTable}
             onChange={(e) =>
               setSourceConfig({
                 ...sourceConfig,
                 stagingTable: e.target.value,
               })
             }
           />
          {fileType ==="json" &&(
           <TextField
             label="Depth"
             size="small"
             value={sourceConfig.depth}
             onChange={(e) =>
               setSourceConfig({
                 ...sourceConfig,
                 depth: e.target.value,
               })
             }
           />
          )}

          {fileType ==="xml" &&(
           <TextField
             label="Content Tag"
             size="small"
             value={sourceConfig.contentTag}
             onChange={(e) => {
               setcontentTag(e.target.value)
               setSourceConfig({
                 ...sourceConfig,
                 contentTag: e.target.value,
               })
             }}
           />

          )}
          {fileType ==="csv" &&(
           <TextField
             label="Delimiter"
             size="small"
             value={sourceConfig.delimiter || ","}
             onChange={(e) =>
               setSourceConfig({
                 ...sourceConfig,
                 delimiter: e.target.value,
               })
             }
           />
          )}


         </div>
      
     </CardContent>
   </Card>

   {fileType === "csv" && (
   <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <label>
          <input
            type="radio"
            name="manualSchema"
            value="true"                // value for radio (can be string)
            checked={manualSchema}       // checked when true
            onChange={() =>  { 
              setManualSchema(true)
              setSourceConfig({
                ...sourceConfig,
                manualSchema: true
              })
            }}
          />
          I will declare staging table schema manually
        </label>

        <label style={{ marginLeft: "16px" }}>
          <input
            type="radio"
            name="manualSchema"
            value="false"
            checked={!manualSchema}       // checked when false
            onChange={() => { 
            setManualSchema(false)
            setSourceConfig({
              ...sourceConfig,
              manualSchema: false,
            })
          }}
          />
          Let system infer the schema automatically
        </label>
      </CardContent>
    </Card>
    )}

  {fileType === "csv" && ( 
   <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
     <CardContent sx={{ p: 3 }}>
     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
       <Typography variant="h6" sx={{ fontWeight: 600, display: "flex", justifyContent: "space-between", alignItems: "center" }}>Non-Standard File Properties 
       </Typography>
       <InfoTip
        keyword="non_standard_config_fields"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div><Button
      variant="outlined"
      size="small"
      startIcon={<FaEraser/>}
      onClick={clearAdditionalProps}
      sx={{ textTransform: "none" }}
      >
        Clear
      </Button>
       <Divider sx={{ my: 2 }} />
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Switch
        checked={additionalOptions}
        onChange={(e) => {
          setAdditionalOptions(e.target.checked)
          setSourceConfig({
            ...sourceConfig,
            additionalOptions: e.target.checked,
          })
        }}
      />
    </div>

    
    {additionalOptions && (
      <div style={{ display: "grid", gap: "12px", marginTop: "12px" }}>
        <FormControl fullWidth size="small">
            <InputLabel id="file-type-label">Header Identifier</InputLabel>
            <Select
              labelId="file-type-label"
              value={headerIdentifier}
              label="File Type"
              onChange={(e) => {
                setHeaderIdentifier(e.target.value)
                setSourceConfig({
                  ...sourceConfig,
                  headerIdentifier: e.target.value,
                })
              }}
            >
              <MenuItem value="line">Line</MenuItem>
              <MenuItem value="column">Column</MenuItem>
            </Select>
          </FormControl>

         <TextField
          label="Header Row Identifier"
          size="small"
          value={headerRowIdentifier}
          onChange={(e) => {
            setHeaderRowIdentifier(e.target.value)
            setSourceConfig({
              ...sourceConfig,
              headerRowIdentifier: e.target.value,
            })
          }}
          placeholder="Keyword + line number to identify header row in multi-header files."
        />
        <TextField
          label="Header Row Numbers"
          size="small"
          value={headerRowNumber}
          onChange={(e) => {
            setHeaderRowNumber(e.target.value)
            setSourceConfig({
              ...sourceConfig,
              headerRowNumber: e.target.value,
            })
          }}
          placeholder="Line numbers to identify header row in multi-header files."
        />
        <FormControl fullWidth size="small">
            <InputLabel id="file-type-label">Header Selection</InputLabel>
            <Select
              labelId="file-type-label"
              value={headerSelection}
              label="File Type"
              onChange={(e) => {
                setHeaderSelection(e.target.value)
                setSourceConfig({
                  ...sourceConfig,
                  headerSelection: e.target.value,
                })
              }}
            >
              <MenuItem value="">
                <em> </em>
              </MenuItem>
              <MenuItem value="lifo">Last in First Out</MenuItem>
              <MenuItem value="sequential">Sequential</MenuItem>
            </Select>
          </FormControl>
        <TextField
          label="Trim Suffix"
          size="small"
          value={trimSuffix}
          onChange={(e) => {
            setTrimSuffix(e.target.value)
            setSourceConfig({
              ...sourceConfig,
              trimSuffix: e.target.value,
            })
          }}
          placeholder="Enter suffix to trim form row..."
        />
      </div>
    )}
    </CardContent>
    </Card>
  )}

    {/* Queries */}
   <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
     <CardContent sx={{ p: 3 }}>
     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
         <Typography variant="h6" sx={{ fontWeight: 600 }}>
           Queries & Validations
         </Typography>
         <InfoTip
        keyword="queries_validations"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
       <Divider sx={{ my: 2 }} />

      {queries.map((q, i) => (
         <Card
           key={i}
           variant="outlined"
           sx={{
             borderRadius: 2,
             p: 2,
             mb: 2,
             position: "relative",
           }}
         >
           <TextField
             fullWidth
             size="small"
             label="Query description"
             value={q.description}
             onChange={(e) => 
              updateQuery(i, "description", e.target.value)}
             sx={{ mb: 1 }}
           />
           <TextField
             fullWidth
             size="small"
             label="Validation (optional)"
             value={q.validation}
             onChange={(e) => updateQuery(i, "validation", e.target.value)}
             sx={{ mb: 2 }}
           />

    {/* Final Output */}
   <Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
     <CardContent sx={{ p: 3 }}>
       <Typography variant="h6" sx={{ fontWeight: 600 }}>
         Destination
       </Typography>
       <Divider sx={{ my: 2 }} />
       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
         <Switch
           checked={q.finalQuery}
           onChange={(e) => {
            setFinalQuery(e.target.checked)
            setSourceConfig({
              ...sourceConfig,
              finalQuery: e.target.checked
            })
            updateQuery(i, "finalQuery", e.target.checked)
          }}
         />
         <Typography variant="body2">Write to destination?</Typography> 
       </div>
       {q.finalQuery && (
         <TextField
           fullWidth
           size="small"
           label="Describe final query"
           value={q.finalQueryDescription}
           onChange={(e) => { 
            setFinalQueryDescription(e.target.value)
            setSourceConfig({
              ...sourceConfig,
              finalQueryDescription: e.target.value
            })
            updateQuery(i, "finalQueryDescription", e.target.value)
           }}
           sx={{ mt: 1 }}
         />
       )}
       <div
         style={{
           display: "flex",
           alignItems: "center",
           gap: "8px",
           marginTop: "16px",
         }}
       >
       </div>
       {q.finalQuery && (
         <div style={{ display: "grid", gap: "16px", marginTop: "12px" }}>
           <FormControl fullWidth size="small">
             <InputLabel>Export Format</InputLabel>
             <Select
               value={q.exportFormat}
               onChange={(e) => {
                setExportFormat(e.target.value)
                setSourceConfig({
                  ...sourceConfig,
                  exportFormat: e.target.value
                  
                })
                updateQuery(i, "exportFormat", e.target.value)
               }}
               label="Export Format"
             >
               <MenuItem value="csv">CSV</MenuItem>
               <MenuItem value="parquet">Parquet</MenuItem>
               <MenuItem value="table">Table</MenuItem>
             </Select>
           </FormControl>
           <TextField
             label="Destination (e.g. output.csv)"
             fullWidth
             size="small"
             value={q.exportDest}
             onChange={(e) => {
              setExportDest(e.target.value)
              setSourceConfig({
                ...sourceConfig,
                exportDest: e.target.value
              })
              updateQuery(i, "exportDest", e.target.value)
             }}
           />
         </div>
       )}
     </CardContent>
      </Card>
        {/* Disable Generation Checkbox */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
          <Checkbox
            checked={!!q.disableGeneration}
            onChange={(e) => updateQuery(i, "disableGeneration", e.target.checked)}
            size="small"
            sx={{
              color: "green",
              "&.Mui-checked": {
                color: "green",
              },
            }}
          />
          <Typography variant="body2">Disable generation</Typography>
       </div>
       
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
           <Button
             variant="outlined"
             color="error"
             size="small"
             startIcon={<FaTrash />}
             onClick={() => deleteQuery(i)}
             sx={{ textTransform: "none" }}
           >
             Delete
           </Button>
      </div>

         </Card>
       ))}
       
       <Button
         variant="contained"
         size="small"
         onClick={addQuery}
         sx={{ textTransform: "none",
          backgroundColor: "#2563eb",
          "&:hover": {
            backgroundColor: "#1565c0",
            },

         }}
       >
         + Add Query
       </Button>
   </CardContent>
   </Card>


   <div style={{ display: "flex", justifyContent: "flex-end" }}>
     <Button
       onClick={() => {
        if (!apiKey || apiKey.trim() === "") {
          setErrorMessage("API key cannot be empty");
          setShowErrorMessage(true)
          return;
        }
        handleAgentAi()
      }}
       variant="contained"
       sx={{ borderRadius: 2, textTransform: "none", px: 3,
        backgroundColor: "#2563eb",
        "&:hover": {
            backgroundColor: "#1565c0",
        }, 
      }}
      >
        {loading ? (
          <>
            <span className="spinner" /> Generating Config...
          </>
        ) : (
          'Preview Config'
        )}  
      </Button>
        </div>
      </div>
      )}

{/* Conditionally render AgentAI UI for Mqtt when selected */}
{configType === "agentai" && featureRef.current === "mqtt" && (

<div style={{ maxWidth: 800, margin: "0 auto", padding: "24px" }}>

 <Typography variant="h6" sx={{ fontWeight: 600 }}>
     Generate Configuration with AI Agent
 </Typography>

{/* Model Selection */}
<div style={{ marginTop: "16px" }}>
<Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
  <CardContent sx={{ p: 3 }}>

  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      Select LLM Model
    </Typography>
    <InfoTip
   keyword="select_llm"
   onLoad={(text) => {
     setDoc(text);
     setOpenDoc(true);
   }}
   />
   </div>
    <Divider sx={{ my: 2 }} />
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginTop: "16px",
      }}
    >
    </div>
      <div style={{ display: "grid", gap: "16px", marginTop: "12px" }}>
        <FormControl fullWidth size="small">
          <InputLabel>LLM Model</InputLabel>
          <Select
            value={model}
            onChange={(e) => {
             setModel(e.target.value)
             setSourceConfig({
               ...sourceConfig,
               model: e.target.value
             })
            }}
            label="LLM Model"
          >
         <MenuItem value="claude-haiku-4-5-20251001">claude-haiku-4-5-20251001</MenuItem>
         <MenuItem value="gpt-4o-mini">gpt-4o-mini(OpenAI)</MenuItem>
          </Select>
        </FormControl>
        <TextField
   label="API Key"
   fullWidth
   size="small"
   type={showKey ? "text" : "password"} // hide/show text
   value={apiKey}
   onChange={(e) => setApiKey(e.target.value)}
   InputProps={{
     endAdornment: (
       <InputAdornment position="end">
         <IconButton
           onClick={() => setShowKey(!showKey)}
           edge="end"
           size="small"
           aria-label="toggle API key visibility"
         >
           {showKey ? <VisibilityOff /> : <Visibility />}
         </IconButton>
       </InputAdornment>
     ),
   }}
 />
      </div>
  </CardContent>
</Card>
</div>
{/* Source Config */}
<Card variant="outlined" sx={{ borderRadius: 6, boxShadow: 1, mb: 3 }}>
  <CardContent sx={{ p: 3 }}>
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
         <Typography
           variant="h6"
           sx={{ fontWeight: 600, display: "flex", justifyContent: "space-between", alignItems: "center" }}
         >
           Set Mandatory fields in config
        </Typography>
        <InfoTip
        keyword="mandatory_config_fields"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
        <br></br>
      <Button
        variant="outlined"
        size="small"
        startIcon={<FaEraser />}
        onClick={clearSourceConfig}
        sx={{ textTransform: "none" }}
      >
        Clear
      </Button>

    <Divider sx={{ my: 2 }} />
      <div style={{ display: "grid", gap: "16px" }}>
      <TextField
        label="Host"
        size="small"
        value={sourceConfig.host}
        onChange={(e) =>
          setSourceConfig({ ...sourceConfig, host: e.target.value })
        }
      />
      <TextField
        label="Port"
        size="small"
        value={sourceConfig.port}
        onChange={(e) =>
          setSourceConfig({ ...sourceConfig, port: e.target.value })
        }
      />
        <TextField
          label="Topic"
          size="small"
          value={sourceConfig.topic}
          onChange={(e) =>
            setSourceConfig({ ...sourceConfig, topic: e.target.value })
          }
        />
        <TextField
          label="Database"
          size="small"
          value={sourceConfig.database}
          onChange={(e) =>
            setSourceConfig({ ...sourceConfig, database: e.target.value })
          }
        />
        <TextField
          label="Staging Table"
          size="small"
          value={sourceConfig.stagingTable}
          onChange={(e) =>
            setSourceConfig({
              ...sourceConfig,
              stagingTable: e.target.value,
            })
          }
        />
      </div>
  </CardContent>
</Card>


 {/* Queries */}
<Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
  <CardContent sx={{ p: 3 }}>
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Queries & Validations
        </Typography>
        <InfoTip
      keyword="queries_validations"
      onLoad={(text) => {
        setDoc(text);
        setOpenDoc(true);
      }}
      />
      </div>
    <Divider sx={{ my: 2 }} />

   {queries.map((q, i) => (
      <Card
        key={i}
        variant="outlined"
        sx={{
          borderRadius: 2,
          p: 2,
          mb: 2,
          position: "relative",
        }}
      >
        
        <TextField
          fullWidth
          size="small"
          label="Query schedule"
          value={q.schedule}
          onChange={(e) => 
           updateQuery(i, "schedule", e.target.value)}
          sx={{ mb: 1 }}
        />
        <TextField
          fullWidth
          size="small"
          label="Query description"
          value={q.description}
          onChange={(e) => 
           updateQuery(i, "description", e.target.value)}
          sx={{ mb: 1 }}
        />
        <TextField
          fullWidth
          size="small"
          label="Validation - Add query and condition (optional)"
          value={q.validation}
          onChange={(e) => updateQuery(i, "validation", e.target.value)}
          sx={{ mb: 2 }}
        />

 {/* Final Output */}
<Card variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, mb: 3 }}>
  <CardContent sx={{ p: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      Destination
    </Typography>
    <Divider sx={{ my: 2 }} />
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Switch
        checked={q.finalQuery}
        onChange={(e) => {
         setFinalQuery(e.target.checked)
         setSourceConfig({
           ...sourceConfig,
           finalQuery: e.target.checked
         })
         updateQuery(i, "finalQuery", e.target.checked)
       }}
      />
      <Typography variant="body2">Write to destination?</Typography> 
    </div>
    {q.finalQuery && (
      <TextField
        fullWidth
        size="small"
        label="Describe query to export data to storage"
        value={q.finalQueryDescription}
        onChange={(e) => { 
         setFinalQueryDescription(e.target.value)
         setSourceConfig({
           ...sourceConfig,
           finalQueryDescription: e.target.value
         })
         updateQuery(i, "finalQueryDescription", e.target.value)
        }}
        sx={{ mt: 1 }}
      />
    )}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginTop: "16px",
      }}
    >
    </div>
    {q.finalQuery && (
      <div style={{ display: "grid", gap: "16px", marginTop: "12px" }}>
        <FormControl fullWidth size="small">
          <InputLabel>Export Format</InputLabel>
          <Select
            value={q.exportFormat}
            onChange={(e) => {
             setExportFormat(e.target.value)
             setSourceConfig({
               ...sourceConfig,
               exportFormat: e.target.value
               
             })
             updateQuery(i, "exportFormat", e.target.value)
            }}
            label="Export Format"
          >
            <MenuItem value="csv">CSV</MenuItem>
            <MenuItem value="parquet">Parquet</MenuItem>
            <MenuItem value="table">Table</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Destination name (e.g. output.csv)"
          fullWidth
          size="small"
          value={q.exportDest}
          onChange={(e) => {
           setExportDest(e.target.value)
           setSourceConfig({
             ...sourceConfig,
             exportDest: e.target.value
           })
           updateQuery(i, "exportDest", e.target.value)
          }}
        />
      </div>
    )}
  </CardContent>
   </Card>

    {/* Disable Generation Checkbox */}
    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
            <Checkbox
              checked={!!q.disableGeneration}
              onChange={(e) => updateQuery(i, "disableGeneration", e.target.checked)}
              size="small"
              sx={{
                color: "green",
                "&.Mui-checked": {
                  color: "green",
                },
              }}
            />
            <Typography variant="body2">Disable generation</Typography>
        </div>
       

        <Button
          variant="outlined"
          color="error"
          size="small"
          startIcon={<FaTrash />}
          onClick={() => deleteQuery(i)}
          sx={{ textTransform: "none" }}
        >
          Delete
        </Button>
        
      </Card>
    ))}
    
    <Button
      variant="contained"
      size="small"
      onClick={addQuery}
      sx={{ textTransform: "none",
       backgroundColor: "#2563eb",
       "&:hover": {
         backgroundColor: "#1565c0",
         },

      }}
    >
      + Add Query
    </Button>
</CardContent>
</Card>


<div style={{ display: "flex", justifyContent: "flex-end" }}>
  <Button
    onClick={() => {
     if (!apiKey || apiKey.trim() === "") {
       setErrorMessage("API key cannot be empty");
       setShowErrorMessage(true)
       return;
     }
     handleAgentAi()
   }}
    variant="contained"
    sx={{ borderRadius: 2, textTransform: "none", px: 3,
     backgroundColor: "#2563eb",
     "&:hover": {
         backgroundColor: "#1565c0",
     }, 
   }}
   >
     {loading ? (
       <>
         <span className="spinner" /> Generating Config...
       </>
     ) : (
       'Preview Config'
     )}  
   </Button>
     </div>
   </div>
)}

<div
    style={{
      marginTop: "16px",
      borderRadius: "8px",
      padding: "8px",
    }}
  >
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      maxWidth: 850,
      margin: "0 auto",
    }}
  >
    {/* Copy Button */}
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Tooltip title="Copy JSON to clipboard">
        <IconButton
          size="small"
          onClick={() => {
            navigator.clipboard.writeText(formData);
          }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>


  <div style={{ position: "relative", width: "100%" }}>
  {/* ✅ InfoTip on right-middle */}
  <div
    style={{
      position: "absolute",
      right: "-35px",      // move outside editor
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
    }}
  >
    <InfoTip
      keyword="config_editor"
      onLoad={(text) => {
        setDoc(text);
        setOpenDoc(true);
      }}
    />
  </div>
      <CodeMirror
          value={formData}
          theme="light"
          height="300px" 
          width="100%" 
          extensions={[
            json(),
            jsonTooltipExtension // 👈 Add your tooltip extension
          ]}
          onChange={(value) => {
            try {
              const parsed = JSON.parse(value);
              const pretty = JSON.stringify(parsed,null,2);
              setFormData(pretty);
              setJsonError(null);
            } catch (err) {
              setJsonError('Invalid JSON syntax');
            }
          }}
          style={{
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
          }}
      />
      </div>

    {jsonError && (
        <Box sx={{ color: "error.main", fontSize: "0.875rem" }}>
          {jsonError}
        </Box>
      )}

    </Box>
    </div>

    <div style={{ position: "relative", width: "100%" }}>
    <div
    style={{
      position: "absolute",
      right: "-35px",      // move outside editor
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
    }}
  >
    <InfoTip
      keyword="config_file_details"
      onLoad={(text) => {
        setDoc(text);
        setOpenDoc(true);
      }}
    />
  </div>

    <div
    style={{
      marginTop: "16px",
      borderRadius: "6px",
      padding: "8px",
    }}
  >
    <Card variant="outlined" sx={{ borderRadius: 6, boxShadow: 1, mb: 3 ,overflow: "hidden" }}>
    <CardContent sx={{ p: 3 }}>
      
    <div className="form-group" style={{ marginTop: "16px" }}>
      <label htmlFor="fileNameInput">File Name</label>
      <input
        type="text"
        id="fileNameInput"
        className="form-control"
        value={editFileName}
        onChange={(e) => setEditFileName(e.target.value)}
        placeholder="Enter file name..."
        style={{
          width: "300px",   // or "100%" if you want full width
          padding: "8px",
          fontSize: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }} 
      />
      </div>

     <div className="form-group">
        <label htmlFor="dataFilesDropdown">Data Files</label>
        <select
          id="dataFilesDropdown"
          className="form-control"
          value={selectedFilePath}
          onChange={(e) => setSelectedFilePath(e.target.value)}
         style={{
            width: "300px",   // or "100%" if you want full width
            padding: "8px",
            fontSize: "16px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            color: selectedFilePath ? "#000" : "#616161"
          }} 
        >
          <option value="">Select a data file...</option>
          {dataFiles?.children?.map((file, index) => (
            <option key={index} value={file.path}>
              {file.info?.name || file.path}
            </option>
          ))}
        </select>
      </div>

    <div className="form-group">
      <label htmlFor="versionInput">Version</label>
      <input
        type="text"
        className="form-control"
        id="versionInput"
        placeholder="Enter custom version"
        value={version}
        onChange={(e) => setVersion(e.target.value)}
        style={{
          width: "300px",   // or "100%" if you want full width
          padding: "8px",
          fontSize: "16px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }} 
      />
    </div>
    </CardContent>
    </Card>
    </div>
    </div>

    <div style={{ position: "relative", width: "100%" }}>
    <div
    style={{
      position: "absolute",
      right: "-35px",      // move outside editor
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
    }}
  >
    <InfoTip
      keyword="config_buttons"
      onLoad={(text) => {
        setDoc(text);
        setOpenDoc(true);
      }}
    />
  </div>

    
    <div style={{
    display: "flex",
    gap: "16px",      // space between the buttons
    justifyContent: "flex-end", // align to the right, change to "center" if needed
    marginTop: "24px", // space above buttons
    marginBottom: "40px", // space below buttons
    padding: "8px",    // optional padding inside wrapper
  }}> 
  
    <SuccessButton
            className="btn btn-new-success"
            type="button"
            style={{
              backgroundColor: "#2e7d32", // MUI success green
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontFamily: "'Roboto','Inter','Segoe UI',sans-serif",
              fontWeight: 700,
              fontSize: "0.875rem", // matches MUI's small button font
              letterSpacing: "0.3px",
              padding: "6px 16px",
              textTransform: "none",
              boxShadow: "none",
              transition: "background-color 0.3s ease, transform 0.1s ease",
            }}
            onClick={() => {
              if (jsonError) {
                setErrorMessage("Fix the JSON before submitting");
                setShowErrorMessage(true)
                return;
              }

              if (!editFileName || editFileName.trim() === "") {
                setErrorMessage("File name cannot be empty");
                setShowErrorMessage(true)
                return;
              }

              if (!selectedFilePath || selectedFilePath.trim() === "") {
                setErrorMessage("Data File cannot be empty");
                setShowErrorMessage(true)
                return;
              }


              handleTest(formData);  // submit with updated formData
            }}
           >
            {loading ? (
            <>
            <span className="spinner" /> Testing...
           </>
           ) : (
                'Test'
            )}  
          </SuccessButton>

          <SuccessButton 
            style={{
              backgroundColor: "#2e7d32", // MUI success green
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontFamily: "'Roboto','Inter','Segoe UI',sans-serif",
              fontWeight: 700,
              fontSize: "0.875rem", // matches MUI's small button font
              letterSpacing: "0.3px",
              padding: "6px 16px",
              textTransform: "none",
              boxShadow: "none",
              transition: "background-color 0.3s ease, transform 0.1s ease",
            }}
            onClick={() => {
              if (jsonError) {
                setErrorMessage("Fix the JSON before submitting");
                setShowErrorMessage(true)
                return;
              }

              if (!editFileName || editFileName.trim() === "") {
                setErrorMessage("File name cannot be empty");
                setShowErrorMessage(true)
                return;
              }

              const updatedFormData = {
                ...formData,
              };

              handleSave(formData);  // submit with updated formData
            }}
           >
            {loading ? (
            <>
            <span className="spinner" /> Saving...
            </>
           ) : (
            'Save'
            )}  
           </SuccessButton >
           <CancelButton className="btn btn-new-warning" type="button" onClick={() => navigate('/listConnectionPage')}>
            Cancel
          </CancelButton>

          <BuildButton
          disabled={isDisabled}
          onClick={() => {
            if (isDisabled) return;

            Swal.fire({
              title: 'Confirm Build',
              text: `Are you sure you want to build ${version}? This will increase license costs?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Build',
            }).then((result) => {
              if (result.isConfirmed) handleBuild();
            });
          }}
        >
          {loading ? "Building..." : "Add to Build"}
      </BuildButton>
      </div>
      </div>

      {/* Boxes */}
      <div className="boxes-container">
        {isHovered && isHovered.tooltip && (
          <HoverBox visible={isHovered} content={isHovered.tooltip} />
        )}

      </div>
      </div>

      
  {/* === Drawer Container === */}
  <div
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      width: activeDrawer ? DRAWER_WIDTHS[activeDrawer] : 0,
      height: "100%",
      transition: "width 0.3s ease",
      overflow: "hidden",
      background: "#fff",
      borderLeft: activeDrawer ? "1px solid #ccc" : "none",
      boxShadow: activeDrawer ? "-2px 0px 5px rgba(0,0,0,0.2)" : "none",
      display: "flex",
      flexDirection: "column",
      zIndex: 1000,
    }}
  >
  {/* Logs Drawer */}
  {activeDrawer === "logs" && (
    <div style={{ flex: 1 }}>
      <div
        style={{
          flexShrink: 0,
          width: 800,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          borderBottom: "1px solid #ccc",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <label style={{ fontWeight: "bold" }}>Log Output</label>
        <InfoTip
        keyword="log_output"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
      </div>

      <div style={{ flex: 1, padding: "10px" }}>
  <div style={{ display: "flex", justifyContent: "space-between" }}>
  <button
      onClick={() => {
        if (!selectedFilePath || selectedFilePath.trim() === "") {
          setErrorMessage("Data File cannot be empty for logs");
          setShowErrorMessage(true)
          return;
        }
        fetchLogs(Math.max(offset - 50, 0));
      }}
      variant="contained"
      sx={{
        backgroundColor: "#2563eb",
        fontWeight: 600,
        color: "#fff",
        textTransform: "none",
        borderRadius: "6px",
        px: 3,
        py: 1,
        "&:hover": {
          backgroundColor: "#1e40af",
        },
      }}
    >
      Newer
  </button>

    <button
      onClick={() => {
        if (!selectedFilePath || selectedFilePath.trim() === "") {
          setErrorMessage("Data File cannot be empty for logs");
          setShowErrorMessage(true)
          return;
        }
        fetchLogs(Math.max(offset + 50, 0));
      }}
    >
      Older
    </button>
  </div>
  <br></br>
  {/* Replaces textarea with styled, scrollable log display */}
  <div
    id="logOutput"
    style={{
      width: "95%",
      height: "600px",
      fontFamily: "monospace",
      backgroundColor: "#1e1e1e",
      color: "#dcdcdc",
      resize: "none",
      overflowY: "scroll",
      padding: "10px",
      border: "1px solid #444",
      borderRadius: "6px",
      whiteSpace: "pre-wrap",
    }}
    dangerouslySetInnerHTML={{
      __html:
        logContent ||
        "<span style='color:gray;'>Run test or click buttons to view existing logs...</span>",
    }}
  />

  
</div>

    </div>
  )}

  {/* Databases Drawer */}
  {activeDrawer === "databases" && (
    <div style={{ flex: 1, padding: "16px", overflowY: "auto" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "300px" }}>
    <h3 style={{ fontSize: "16px", fontWeight: 600, marginBottom: "12px", color: "#111827" }}>
        Database
    </h3>
    <InfoTip
        keyword="explore_databases"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>
    <select
        id="database"
        className="form-control"
        value={selectedDatabase}
        onChange={handleDatabaseChange}
        style={{
          padding: "6px",
          fontSize: "13px",
          borderRadius: "6px",
          border: "1px solid #d1d5db",
          marginBottom: "10px",
          width: "240px",
        }}
      >
        {renderSchemaOptions()}
      </select>

      <h3 style={{ fontSize: "16px", fontWeight: 700, marginBottom: "12px", color: "#111827" }}>
            Table
      </h3>
      <select
        id="table"
        className="form-control"
        value={selectedTable}
        onChange={handleTableChange}
        style={{
          padding: "6px",
          fontSize: "13px",
          borderRadius: "6px",  
          border: "1px solid #d1d5db",
          marginBottom: "12px",
          width: "240px",
        }}
      >
        {renderTable1Options()}
      </select>

      <button 
      onClick={() => fetchListDataConnections()}
      style={{ marginLeft: "16px" }}
      >
        Refresh
      </button>

        

      {resultCols.length > 0 ? (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "12px",
      }}
    >
      <thead style={{ backgroundColor: "#f3f4f6", position: "sticky", top: 0 }}>
  <tr>
    {/* Add a new header for the row index */}
    <th
      style={{
        padding: "6px",
        borderBottom: "1px solid #e5e7eb",
        textAlign: "left",
        width: "40px",
      }}
    >
      #
    </th>

    {resultCols.map((col, i) => (
      <th
        key={i}
        style={{
          padding: "6px",
          borderBottom: "1px solid #e5e7eb",
          textAlign: "left",
        }}
      >
        {col}
      </th>
    ))}
  </tr>
</thead>

<tbody>
  {resultRows.map((row, idx) => (
    <tr key={idx}>
      {/* Add a cell with row index (1-based) */}
      <td
        style={{
          padding: "4px",
          borderBottom: "1px solid #f1f5f9",
          color: "#6b7280",
          textAlign: "right",
          fontSize: "0.875rem",
        }}
      >
        {idx + 1}
      </td>

      {row.map((cell, j) => (
        <td
          key={j}
          style={{
            padding: "4px",
            borderBottom: "1px solid #f1f5f9",
            verticalAlign: "top",
          }}
        >
          {String(cell)}
        </td>
      ))}
    </tr>
  ))}
</tbody>

    </table>
  ) : (
    !loading && <p style={{ color: "#9ca3af", textAlign: "center", padding: "8px" }}>No results yet</p>
  )}

  <div style={{
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "400px",   // 👈 controls table height
    marginTop: "20px",
    marginBottom: "30px",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    paddingBottom: "16px",
  }}>
        <table className="table" style={{ minWidth: "600px" }}>
          <thead>
            <tr>
              <th>Column Name</th>
              <th>Data Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {rightList.map((column, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    value={column.name}
                    onChange={(e) =>
                      handleInputChange(index, "name", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={column.dataType || ""}
                    onChange={(e) =>
                      handleInputChange(index, "dataType", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={column.description || ""}
                    onChange={(e) =>
                      handleInputChange(index, "description", e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )}

</div>

 {/* === Control Buttons (Pull Tabs) === */}
{activeDrawer === null && (
  <>
    {/* Logs button */}
    <Button
      onClick={() => setActiveDrawer("logs")}
      variant="contained"
      size="small"
      sx={{
        backgroundColor: "#2563eb",
        fontWeight: 500,
        position: "fixed",
        top: "15%",
        right: 0,
        transform: "translateY(-50%)",
        borderRadius: "8px 0 0 8px",
        zIndex: 1100,
        "&:hover": {
          backgroundColor: "#1565c0",
        },
      }}
    >
      View Test Logs ⬅
    </Button>

    {/* Databases button */}
    <Button
      onClick={() => setActiveDrawer("databases")}
      variant="contained"
      size="small"
      sx={{
        backgroundColor: "#2563eb",
        position: "fixed",
        top: "25%",
        right: 0,
        transform: "translateY(-50%)",
        borderRadius: "8px 0 0 8px",
        zIndex: 1100,
        "&:hover": {
          backgroundColor: "#1565c0",
        },
      }}
    >
      Explore Table Schemas ⬅
    </Button>

  </>
)}

{/* Show close button only when a drawer is open */}
{activeDrawer && (
  <Button
    onClick={() => setActiveDrawer(null)}
    variant="contained"
    size="small"
    sx={{
      position: "fixed",
      top:
        activeDrawer === "logs"
          ? "15%"
          : activeDrawer === "databases"
          ? "25%"
          : "35%",
      right: DRAWER_WIDTHS[activeDrawer],
      transform: "translateY(-50%)",
      borderRadius: "8px 0 0 8px",
      zIndex: 1100,
      backgroundColor: "#2563eb",
      "&:hover": {
        backgroundColor: "#1565c0",
      },
    }}
  >
    Close {activeDrawer.charAt(0).toUpperCase() + activeDrawer.slice(1)} ➡
  </Button>
)}

<Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
>

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
    >
  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>
    </div>

  </div>

</Drawer>


  </div>

    );
  }

export default EditConnectionPage;
